<template>
  <c-modal :show="show" class="edit-client" title="New Client" size="lg" @update:show="toggle">
    <c-input
        v-model="client.name"
        label="Name"
        type="text"
        placeholder="Enter client name"
        :lazy="false"
        :is-valid="checkIfValid('name')"
        invalid-feedback="Please enter a client name"
    />
    <c-input
        v-model="client.contactName"
        label="Contact name"
        type="text"
        placeholder="Enter contact name"
        :lazy="false"
        :is-valid="checkIfValid('contactName')"
        invalid-feedback="Please enter a contact name"
    />
    <c-input
      v-model="client.contactEmailAddress"
      label="Contact email address"
      type="text"
      placeholder="Enter email"
      :lazy="false"
      :is-valid="checkIfValid('contactEmailAddress')"
      invalid-feedback="Please enter a valid contact email"
    />
    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" :disabled="isSaving" @click="save">Create</c-button>
        <c-button color="secondary" @click="close">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required, email,
} from 'vuelidate/lib/validators';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'CreateClient',
  mixins: [validationMixin],
  props: {
    show: Boolean,
  },
  data() {
    return {
      isSaving: false,
      client: {
        name: '',
        contactName: '',
        contactEmailAddress: '',
      },
    };
  },
  computed: {
    isValid() {
      return !this.$v.client.$invalid;
    },
    isDirty() {
      return this.$v.client.$anyDirty;
    },
  },
  validations: {
    client: {
      name: {
        required,
      },
      contactName: {
        required,
      },
      contactEmailAddress: {
        required,
        email,
      },
    },
  },
  methods: {
    close() {
      this.client = {
        name: '',
        contactName: '',
        contactEmailAddress: '',
      };
      this.$v.$reset();
      this.$emit('close');
    },
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v.client[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    save() {
      this.$v.$touch();

      if (!this.isValid) {
        return;
      }
      this.isSaving = true;
      this.$http
        .post(buildEndpoint('organisation/client/create'), this.client)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Client created',
            });
            this.$emit('created');
            this.$emit('newClient', response.data.data);
            this.close();
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error creating client',
            });
          }
        })
        .catch((error) => {
          this.isSaving = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
  },
};
</script>
